import * as React from "react";
import SearchView from "../components/searchView/SearchView";
import SelectorView from "../components/selectorView/SelectorView";
import {
    SEARCH_VIEW_PRODUCTS,
    REPERTOIRE,
    INTRAY,
    SIMPLE,
    ADVANCED,
    ALL_ROLES,
    UPDATE_PRODUCTS_ROLE,
    VIEW_PRODUCTS_ROLE,
    EDITABLE_FIELDS,
    TITLE_EDITABLE_FIELDS_VIEW,
    GENERAL_DATA_EDITABLE_FIELDS,
    SEARCH_RESULTS_TABLE
} from "../Consts";
import { setEditableFields, setProductDataSource } from "../../redux/reducers/RepertoireReducer";
import IRepertoireComponentDataItem from "../../redux/types/IRepertoireComponentDataItem";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { IProductSearchQuery } from "../types/IProductSearchQuery";
import { IProductSearchResult } from "../types/IProductSearchResult";
import { FormatFields } from "../../redux/types/FormatFields";
import { SearchRequests } from "../services/SearchRequests";
import { CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, PRODUCT_MAINTENANCE_GROUP } from "../ConfigurationConsts";
import { IActiveAccordion } from "../../redux/types/IActiveAccordion";
import { IResultsPerPage } from "../../redux/types/IResultsPerPage";
import { useMsal } from "@azure/msal-react";
import { ComponentsHelper } from "../../core/services/ComponentHelper";
import { msalConfig } from "../../accounts/types/msalAuthConfig";
import ProductsSearchView from "./ProductSeachView";
import { showUpdateFieldsModal } from "../../redux/reducers/ModalReducer";
import { IRepertoireField } from "../types/IRepertoireField";
import { ITabReduxItem } from "../../redux/types/ITabReduxItem";
import { IShowFieldSettingViewModalProps } from "../components/repertoireModal/RepertoireModal";
import { useAiSearchOption } from "../utils/aiSearchOption";
import { CURRENT_USER_NAME_KEY } from "../../redux/services/AccountSessionStorage";
import { IAddtoPackageResult } from "../types/IAddtoPackageResult";
import { IMyPackagesDetails } from "../types/IMyPackagesDetails";
import { EntityType } from "../types/EntityType";
import { AddToPackageProvider } from "../components/addToPackageButton/AddToPackageContext";
import { hideModal, showYesNoPrompt } from "../../redux/reducers/ModalReducer";

export interface IProductsPageProps {
    productsPageData: IRepertoireComponentDataItem;
    searchViewData: IRepertoireComponentDataItem;
    searchResultsTableData: IRepertoireComponentDataItem;
    dataSource: string;
    setProductDataSource: typeof setProductDataSource;
    getProductDetails: (dataSource: string, productCoreID: number, productMaintenanceGeneralDataView: IRepertoireComponentDataItem, formats?: FormatFields[], openEntityForWorflowSession?: boolean, openNewTab?: boolean, id1?: string, id2?: string, productType?: string, originOfRevision?: string, enableCuesheet?: boolean, cuesheetDatasource?: any, productionType?: string, musicDuration?: number[], isOpenedInSecondTab?: boolean) => void;
    addNewProduct: (lookups: ILookupDictionary, isNew?: boolean,productMaintenanceGeneralDataView?: IRepertoireComponentDataItem,formats?: FormatFields[]) => void;
    searchProducts: (query: IProductSearchQuery, modalOpen: boolean) => void;
    productSearchResults: IProductSearchResult[];
    lookupValues: ILookupDictionary;
    searchSuccessful: boolean;
    productMaintenanceGeneralDataViewData: IRepertoireComponentDataItem;
    expandedProductResults: number[];
    expandAll: boolean;
    expandProductResult: (productResult: number) => void;
    expandAllResults: () => void;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    currentPage?: number;
    resetPagination: (repertoireSection: string) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => void;
    sortSearchResults: (name: string, results: any) => void;
    roles?: string[];
    saveRoles?: (roles: string[]) => void;
    getShowCommentSubjectAsDropdownConfigurationParameter?: (group: string) => void;
    useNewUIgridSearchResults: boolean;
    enableCuesheet:boolean;
    cuesheetDatasource:any;
    currentUser?:string;
    myPackagesResult?: IMyPackagesDetails[] | { data?: IMyPackagesDetails[]; };
    addToPackages?: (userName: string, entityType: string, entityIds: number[]) => Promise<IAddtoPackageResult>;
    removeFromPackages?: (userName: string, entityType: string, entityIds: number[]) => Promise<IAddtoPackageResult>;
    getMyPackagesDetails?: (userName: string) => void;
    showYesNoPrompt?: typeof showYesNoPrompt;
    hideModal?: typeof hideModal;
    showUpdateFieldsModal?: typeof showUpdateFieldsModal;
    editableFieldsDataView?: IRepertoireComponentDataItem;
    setEditableFields?: typeof setEditableFields;
    updateComponentFieldsItems?: (fields: IRepertoireField[],
    componentName: string,
    componentInstance: string,
    componentDataFieldName: string,
    tabs: ITabReduxItem[],
    activeTab: number) => void;
    editableFields?: IRepertoireField[];
    activeTab?: number;
    tabs?: ITabReduxItem[];
    dataGridTableData?: IRepertoireComponentDataItem;
}

const ProductsPage = ({
    productsPageData,
    saveRoles,
    dataSource,
    searchViewData,
    setProductDataSource,
    searchResultsTableData,
    searchProducts,
    productSearchResults,
    lookupValues,
    searchSuccessful,
    getShowCommentSubjectAsDropdownConfigurationParameter,
    getProductDetails,
    addNewProduct, 
    productMaintenanceGeneralDataViewData,
    expandedProductResults,
    roles,
    expandAll,
    expandProductResult,
    expandAllResults,
    indexOfFirstResult,
    indexOfLastResult,
    resultsPerPage,
    currentPage,
    resetPagination,
    sortSearchResults,
    defaultActiveAccordions,
    allResultsPerPage,
    updateUserPreferences, 
    updatePagination,
    useNewUIgridSearchResults,
    enableCuesheet,
    cuesheetDatasource,
    currentUser,
    addToPackages,
    myPackagesResult,
    removeFromPackages,
    getMyPackagesDetails,
    showYesNoPrompt,
    hideModal,
    showUpdateFieldsModal,
    editableFieldsDataView,
    setEditableFields,
    updateComponentFieldsItems,
    editableFields,
    activeTab,
    tabs,
    dataGridTableData
}: IProductsPageProps) => {
    const [searchType, setSearchType] = React.useState(SIMPLE)
    const [loaded, setLoaded] = React.useState(false)
    const { instance, accounts } = useMsal()
    const { option3, option3Label } = useAiSearchOption(searchViewData, searchType, setSearchType);

    React.useEffect(() => {
        checkIfLoaded();

        const account = accounts[0]
        ComponentsHelper.createBearerHeaderFromAADLogin(instance, account);
        getRoles();
    }, [])

    React.useEffect(() => {
        checkIfLoaded();
    }, [loaded, productsPageData])

    React.useEffect(() => {
        const userName = sessionStorage.getItem(CURRENT_USER_NAME_KEY);

        if (userName) {
            getMyPackagesDetails?.(userName);
        }
    }, [getMyPackagesDetails]);

    const checkIfLoaded = () => {

        if (productsPageData.fields && productsPageData.fields.length > 1 && !loaded) {
            setLoaded(true)
            const header = productsPageData.fields.find(f => f.name === "PageTitle");
            if (header) {
                document.title = header.data;
            }
        }
        if (!loaded && searchResultsTableData && searchResultsTableData.fields && searchResultsTableData.fields.length > 0 && (!editableFields || editableFields.length === 0)){
            setEditableFields(SEARCH_RESULTS_TABLE, SEARCH_VIEW_PRODUCTS)
        }
    }

    const addNewProductLocal = (): void => {
        SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY,PRODUCT_MAINTENANCE_GROUP)
        .then(formats => {
            addNewProduct(lookupValues, true, productMaintenanceGeneralDataViewData, formats);
        })
    }

    const updateUserPagination = (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => {
        updatePagination(indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage, repertoireSection);
        updateUserPreferences(allResultsPerPage, defaultActiveAccordions, undefined, undefined, undefined, indexOfFirstResult, indexOfLastResult, resultsPerPage, repertoireSection);
    }

    let scope =
    {
        scopes: [msalConfig.auth.scope]
    }

    const getRoles = () => {

        instance.acquireTokenSilent({
            ...scope,
            account: accounts[0]
        }).then((response) => {
            const decodedJwtToken = ComponentsHelper.parseJwt(response.accessToken);
            const roles = decodedJwtToken.roles;
            saveRoles(roles);
        }).catch((error) => {
            saveRoles([ALL_ROLES])
        });
    }
    
    const showFieldsModal = () => {
        const fieldsViewData: IRepertoireComponentDataItem = { fields: editableFieldsDataView.fields.filter(x => x.componentInstance === GENERAL_DATA_EDITABLE_FIELDS) };
            const title: string = fieldsViewData.fields.find(item => item.name === TITLE_EDITABLE_FIELDS_VIEW).data;
            const fieldSetting: IShowFieldSettingViewModalProps = {
                componentInstance: EDITABLE_FIELDS,
                componentViewData: fieldsViewData,
                dataGridViewData: dataGridTableData,
                onClickSave: onSaveEditableFields
            }            
            showUpdateFieldsModal(title, fieldSetting);
    }

    const onSaveEditableFields = () => {
        updateComponentFieldsItems(editableFields["default"], SEARCH_RESULTS_TABLE, SEARCH_VIEW_PRODUCTS, SEARCH_RESULTS_TABLE, tabs, activeTab);
    }

    const packages: IMyPackagesDetails[] =
        Array.isArray(myPackagesResult)
            ? myPackagesResult
            : myPackagesResult?.data ?? [];

    const openProductPackage = packages.find(
        packageItem =>
            packageItem.entityType === EntityType.Products &&
            packageItem.status === "Open"
    );

    const packageActionsDisabled =
        Boolean(openProductPackage?.searchCriteriaJson);

    const productPackageItems =
        packageActionsDisabled
            ? []
            : openProductPackage?.packageItems ?? [];

    if (loaded) {
        const {
            fields: {
                1: { data: dataSourceTitle },
                2: { data: searchTypeTitle }
            }
           } = productsPageData;



        const getUpdateRoleDisabled = (): boolean => {
            if (roles && (roles.includes(UPDATE_PRODUCTS_ROLE) || roles.includes(ALL_ROLES))) {
                return false;
            }
            return true;
        }

        const getViewRoleDisabled = (): boolean => {
            if (roles && (roles.includes(VIEW_PRODUCTS_ROLE) || roles.includes(ALL_ROLES))) {
                return false;
            }
            return true;
        }

        const getProductDetailsLocal = (dataSource: string, productID: number, isForWorkflowSession?: boolean, openNewTab?: boolean, id1?: string, id2?: string, type?: string, originOfRevision?: string, productionType?: string, musicDuration?: number[]) => {
            SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, PRODUCT_MAINTENANCE_GROUP)
            .then(formats => {
                getProductDetails(
                    dataSource,
                    productID,
                    productMaintenanceGeneralDataViewData,
                    formats,
                    undefined,
                    undefined,
                    id1,
                    id2,
                    type,
                    originOfRevision,
                    enableCuesheet,
                    cuesheetDatasource,
                    undefined,
                    undefined
                );
            });
        }
        const username = sessionStorage.getItem(CURRENT_USER_NAME_KEY);
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <span className="title">Find Product</span>
                        <div className="newWorkButton" title="Create New Product" hidden={getUpdateRoleDisabled()}>
                            <div className="IconTextButton" onClick={addNewProductLocal}>
                                <i className="icon ms-Icon ms-Icon--CircleAddition"
                                    aria-hidden="true">
                                </i>
                                    New Product
                                </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <SelectorView
                        selection={dataSource}
                        setSelection={setProductDataSource}
                        option1={REPERTOIRE}
                        option1Label={REPERTOIRE}
                        option2={INTRAY}
                        option2Label={INTRAY}
                        selectorTitle={dataSourceTitle}
                    />
                    <SelectorView
                        selection={searchType}
                        setSelection={setSearchType}
                        option1={SIMPLE}
                        option1Label={(searchViewData.fields.find(f => f.name === SIMPLE)?.data || SIMPLE)
                            .toLowerCase().replace(/^./, c => c.toUpperCase())}                          
                        option2={ADVANCED}
                        option2Label={(searchViewData.fields.find(f => f.name === ADVANCED)?.data || ADVANCED)
                            .toLowerCase().replace(/^./, c => c.toUpperCase())}
                        option3={option3}
                        option3Label={option3Label}
                        selectorTitle={searchTypeTitle}
                    />
                </div>
                <AddToPackageProvider
                    initialAddedIds={productPackageItems}
                >
                    {useNewUIgridSearchResults ? (
                        <ProductsSearchView
                            getProductDetails={getProductDetailsLocal}
                            searchProducts={searchProducts}
                            searchViewData={searchViewData}
                            searchResultsTableData={searchResultsTableData}
                            dataSource={dataSource}
                            productSearchResults={productSearchResults}
                            lookupValues={lookupValues}
                            searchSuccessful={searchSuccessful}
                            searchDisabled={getViewRoleDisabled()}
                            getShowCommentSubjectAsDropdownConfigurationParameter={getShowCommentSubjectAsDropdownConfigurationParameter}
                            expandAll={expandAll}
                            expandProductResult={expandProductResult}
                            expandAllResults={expandAllResults}
                            expandedProductResults={expandedProductResults}
                        />)
                        : (
                            <SearchView
                                searchViewData={searchViewData}
                                searchResultsTableData={searchResultsTableData}
                                componentInstance={SEARCH_VIEW_PRODUCTS}
                                modalProps={undefined}
                                dataSource={dataSource}
                                getProductDetails={getProductDetailsLocal}
                                searchProducts={searchProducts}
                                productSearchResults={productSearchResults}
                                lookupValues={lookupValues}
                                hideModal={hideModal}
                                showYesNoPrompt={showYesNoPrompt}
                                removeFromPackages={removeFromPackages}
                                packageActionsDisabled={packageActionsDisabled}
                                searchSuccessful={searchSuccessful}
                                expandedProductResults={expandedProductResults}
                                expandAll={expandAll}
                                expandProductResult={expandProductResult}
                                expandAllResults={expandAllResults}
                                indexOfFirstResult={indexOfFirstResult}
                                indexOfLastResult={indexOfLastResult}
                                resultsPerPage={resultsPerPage}
                                currentPage={currentPage}
                                resetPagination={resetPagination}
                                currentUser={username}
                                roles={roles}
                                addToPackages={addToPackages}
                                updatePagination={updateUserPagination}
                                sortSearchResults={sortSearchResults}
                                searchDisabled={getViewRoleDisabled()}
                                getShowCommentSubjectAsDropdownConfigurationParameter={getShowCommentSubjectAsDropdownConfigurationParameter}
                                groupName={PRODUCT_MAINTENANCE_GROUP}
                                resultPageData={productsPageData}
                                searchType={searchType}
                                showFieldsModal={showFieldsModal}
                            />
                        )}
                </AddToPackageProvider>
            </div>
        );
    }
    return <div />;
}

export default ProductsPage;
